import ProtectedLogo from '../../../components/feature/ProtectedLogo';
import { Link } from 'react-router-dom';

export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleNavigation = (path: string) => {
    if (typeof window.REACT_APP_NAVIGATE === 'function') {
      window.REACT_APP_NAVIGATE(path);
    } else {
      window.location.href = path;
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-50 via-white to-teal-50/30 border-t border-gray-100 py-10 sm:py-12 md:py-16">
      <div className="max-w-[95%] sm:max-w-[90%] lg:max-w-[70%] mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12 mb-8 sm:mb-10 md:mb-12">
          {/* Logo a popis */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6 cursor-pointer group">
              <ProtectedLogo
                src="https://static.readdy.ai/image/555c563fff780fe2630def631567923a/7657cf4116acd66083a1141f7d171df6.png"
                alt="VyŽehlené logo"
                className="h-10 sm:h-12 w-10 sm:w-12 group-hover:scale-105 transition-transform"
                watermarkText="© VyŽehlené 2026"
              />
              <div className="flex flex-col">
                <span className="text-lg sm:text-xl font-bold text-gray-900 group-hover:text-teal-600 transition-colors leading-tight">VyŽehlené</span>
                <span className="text-sm sm:text-base font-semibold text-pink-600 leading-tight">Press Done</span>
              </div>
            </Link>
            <p className="text-sm sm:text-base text-gray-600 leading-relaxed mb-4 sm:mb-6">
              Vracíme vám vyžehlený čas.
            </p>
            <div className="flex gap-3 sm:gap-4">
              <a href="#" className="w-10 h-10 bg-gradient-to-br from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white rounded-full flex items-center justify-center transition-all shadow-md hover:shadow-lg cursor-pointer">
                <i className="ri-facebook-fill text-lg sm:text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gradient-to-br from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 text-white rounded-full flex items-center justify-center transition-all shadow-md hover:shadow-lg cursor-pointer">
                <i className="ri-instagram-line text-lg sm:text-xl"></i>
              </a>
            </div>
          </div>

          {/* Rychlé odkazy */}
          <div>
            <h4 className="text-base sm:text-lg font-bold text-gray-900 mb-4 sm:mb-6">Rychlé odkazy</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('sluzby')}
                  className="text-sm sm:text-base text-gray-600 hover:text-teal-600 transition-colors cursor-pointer"
                >
                  Služby
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('cenik')}
                  className="text-sm sm:text-base text-gray-600 hover:text-teal-600 transition-colors cursor-pointer"
                >
                  Ceník
                </button>
              </li>
              <li>
                <a
                  href="/flexibilni-vyzvedavani"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigation('/flexibilni-vyzvedavani');
                  }}
                  className="text-sm sm:text-base text-gray-600 hover:text-teal-600 transition-colors cursor-pointer flex items-center gap-2"
                >
                  <i className="ri-time-line"></i>
                  Flexibilní hodiny
                </a>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('jak-to-funguje')}
                  className="text-sm sm:text-base text-gray-600 hover:text-teal-600 transition-colors cursor-pointer"
                >
                  Jak to funguje
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('kontakt')}
                  className="text-sm sm:text-base text-gray-600 hover:text-teal-600 transition-colors cursor-pointer"
                >
                  Kontakt
                </button>
              </li>
              <li>
                <a
                  href="/partner"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavigation('/partner');
                  }}
                  className="text-sm sm:text-base text-gray-600 hover:text-pink-600 transition-colors cursor-pointer flex items-center gap-2"
                >
                  <i className="ri-team-line"></i>
                  Lokální partneři
                </a>
              </li>
            </ul>
          </div>

          {/* Kontakt Praha */}
          <div>
            <h4 className="text-base sm:text-lg font-bold text-gray-900 mb-4 sm:mb-6">Praha</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li className="flex items-start gap-2 sm:gap-3">
                <i className="ri-phone-fill text-base sm:text-lg text-teal-500 flex-shrink-0 mt-0.5"></i>
                <a href="tel:+420776166733" className="text-sm sm:text-base text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">
                  +420 776 166 733
                </a>
              </li>
              <li className="flex items-start gap-2 sm:gap-3">
                <i className="ri-mail-fill text-base sm:text-lg text-teal-500 flex-shrink-0 mt-0.5"></i>
                <a href="mailto:ahoj@vyzehlene.com" className="text-sm sm:text-base text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">
                  ahoj@vyzehlene.com
                </a>
              </li>
              <li className="flex items-start gap-2 sm:gap-3">
                <i className="ri-truck-line text-base sm:text-lg text-teal-500 flex-shrink-0 mt-0.5"></i>
                <span className="text-sm sm:text-base text-gray-600">
                  Doprava: 399 Kč
                </span>
              </li>
            </ul>
          </div>

          {/* Kontakt Stará Boleslav */}
          <div>
            <h4 className="text-base sm:text-lg font-bold text-gray-900 mb-4 sm:mb-6">Stará Boleslav</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li className="flex items-start gap-2 sm:gap-3">
                <i className="ri-phone-fill text-base sm:text-lg text-teal-500 flex-shrink-0 mt-0.5"></i>
                <a href="tel:+420603290573" className="text-sm sm:text-base text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">
                  +420 603 290 573
                </a>
              </li>
              <li className="flex items-start gap-2 sm:gap-3">
                <i className="ri-map-pin-line text-base sm:text-lg text-teal-500 flex-shrink-0 mt-0.5"></i>
                <span className="text-sm sm:text-base text-gray-600">
                  A okolí
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Právní odkazy */}
        <div className="border-t border-gray-200 pt-6 sm:pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 sm:gap-6">
            <div className="flex flex-wrap justify-center sm:justify-start gap-4 sm:gap-6 text-xs sm:text-sm text-gray-500">
              <a href="/obchodni-podminky" className="hover:text-teal-600 transition-colors cursor-pointer">
                Obchodní podmínky
              </a>
              <a href="/storno-podminky" className="hover:text-teal-600 transition-colors cursor-pointer">
                Storno podmínky
              </a>
              <a href="/zpracovani-osobnich-udaju" className="hover:text-teal-600 transition-colors cursor-pointer">
                Zpracování osobních údajů
              </a>
            </div>
            <p className="text-xs sm:text-sm text-gray-500 text-center sm:text-right">
              © 2026 VYŽEHLENÉ. Všechna práva vyhrazena.
            </p>
          </div>
          <div className="mt-4 text-center">
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-xs sm:text-sm text-gray-400 hover:text-teal-600 transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
